module.exports = __webpack_public_path__ + "media/images/icon-question-e9e393b02ba0f16c8bc6302eec530349.svg";